const DocumentStar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      fill="#8E33FF"
      stroke="#8E33FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.267 3.332h5.01a.6.6 0 0 1 .391.144l2.58 2.212a.6.6 0 0 0 .39.144h7.095a.6.6 0 0 1 .6.6v2.133a.6.6 0 0 1-.6.6H2.267a.6.6 0 0 1-.6-.6V3.932a.6.6 0 0 1 .6-.6"
    ></path>
    <path
      stroke="#8E33FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M18.334 8.332v3.333M1.667 8.332v7.733a.6.6 0 0 0 .6.6h8.566M15.833 17.501a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"
    ></path>
    <path
      stroke="#8E33FF"
      strokeDasharray="0.3 2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15.834 18.332a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    ></path>
  </svg>
);

export const FeesAndChargesIcon = () => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3333 4.49935V10.8327C18.3333 11.9373 17.4379 12.8327 16.3333 12.8327H3.66666C2.56209 12.8327 1.66666 11.9372 1.66666 10.8327V3.16602C1.66666 2.06145 2.56209 1.16602 3.66666 1.16602H16.3333C17.4379 1.16602 18.3333 2.06145 18.3333 3.16601V4.49935ZM18.3333 4.49935H4.99999"
      stroke="#8E33FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default DocumentStar;
